import React, { useRef, useState, useEffect } from "react";
import { useBoolean } from "@fluentui/react-hooks";
import i18n from "i18next";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import { Button, Link } from "@fluentui/react-components";
import { DocumentPersonRegular } from "@fluentui/react-icons";
import Header from "../Header";

function TermsOfUse(props: any) {
  const termsDE = (
    <div>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            <Button
              icon={<DocumentPersonRegular fontSize={24} color="#ff6600" />}
              appearance="subtle"
            >
              {i18n.t<string>("terms-of-use").toLocaleUpperCase()}
            </Button>
          </StackShim>
        }
      />

      <div className="lueb-ContentBlock">
        <p className="mt-3">Herzlich Willkommen bei LÜBBERING DIGITAL!</p>
        <p>
          Wir bitten Sie, die folgenden Nutzungsbedingungen für die im Rahmen
          von LÜBBERING DIGITAL angebotenen Dienste sorgfältig zu lesen. Die
          Bedingungen gelten für jede Nutzerin/ jeden Nutzer dieser Dienste.
        </p>
        <p>
          Für die Registrierung und Nutzung von LÜBBERING DIGITAL ist es
          erforderlich, dass Sie sich mit der Geltung der Nutzungsbedingungen
          einverstanden erklären. Ihr Einverständnis erklären Sie durch das
          Setzen des entsprechenden Hakens am Ende des Registrierungsprozesses.
          Ohne Ihr Einverständnis ist eine Registrierung und Nutzung der Dienste
          nicht möglich.
        </p>
        <div style={{ margin: "10px" }}></div>
        <p>Anbieter von LÜBBERING DIGITAL ist:</p>
        <div>Johannes Lübbering GmbH</div>
        <div>Industriestraße 4</div>
        <div className="mb-3">33442 Herzebrock-Clarholz</div>
        <div>Telefon: +49 (0) 5245 - 8309 0</div>
        <div className="mb-3">
          E-Mail:{" "}
          <Link href="mailto:info@luebbering.de">info@luebbering.de</Link>
        </div>
        <div className="mb-3">Geschäftsführer: Achim Lübbering</div>
        <div>Registergericht: Amtsgericht Gütersloh</div>
        <div>Registernummer: HRB 5832</div>
        <p>
          Der Anbieter behält sich das Recht vor, die Informationen und
          Leistungen von LÜBBERING DIGITAL jederzeit ohne vorherige Ankündigung
          zu ändern, teilweise oder ganz zu streichen oder zu ergänzen.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h4>§ 1 Geltungsbereich</h4>
        <ol>
          <li>
            <p>
              Die nachfolgenden Bedingungen gelten für die Nutzung der im Rahmen
              von LÜBBERING DIGITAL angebotenen Dienste (im Folgenden "Dienste"
              genannt).
            </p>
            <div>Folgende Dienste sind derzeit umfasst:</div>
            <ul className="lueb-listWithPlusIcon">
              <li>
                <div>L.SP3 Configurator und Quick Finder:</div>
                <p>
                  L.SP3 Configurator und Quick Finder richten sich an Kunden und
                  Interessenten. Es besteht die Möglichkeit, komplette
                  Schraubsysteme zu konfigurieren oder im Rahmen einer
                  Schnellsuche zu überprüfen, ob für die entsprechende Anwendung
                  ein Standardflachabtrieb oder -winkelkopf genutzt werden kann.
                </p>
              </li>
              <li>
                <div>My Toolbox:</div>
                <p>
                  My Toolbox richtet sich ausschließlich an (End-) Kunden,
                  welche die Schraubsysteme (Produkte) des Anbieters tatsächlich
                  im Einsatz haben. Nutzer (z.B. Planer, Instandhalter, o.ä.)
                  können in My Toolbox die im Einsatz befindlichen Produkte
                  registrieren. Dadurch erhalten sie Zugriff auf technische
                  Produktdaten, weitergehende Informationen zu Wartung und
                  Benutzung der Produkte. Zudem erhalten Nutzer Unterstützung
                  bei der Ersatzteilbeschaffung und können die im Einsatz
                  befindlichen Produkte übersichtlich organisieren.
                </p>
              </li>
              <li>
                <div>Partner Lounge:</div>
                <p>
                  Die Partner Lounge bietet die gleichen Funktionen, wie der
                  Dienst „My Toolbox“, richtet sich aber ausschließlich an
                  Vertriebspartner und Händler, die die Schraubsysteme
                  (Produkte) des Anbieters vertreiben.
                </p>
              </li>
              <li>
                <div>Lübbering Academy:</div>
                <p>
                  Lübbering Academy richtet sich vorrangig an die Endanwender
                  von Lübbering-Schraubwerkzeugen sowie an die für die
                  Instandhaltung der Systeme verantwortlichen Personen. Die
                  Nutzer können sich über das entsprechende Schulungsangebot
                  informieren, Schulungen verwalten und organisieren sowie auf
                  Produktvideos und digitale Schulungsunterlagen zugreifen.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              Voraussetzung für die Nutzung der Dienste ist, dass der Nutzer die
              nachfolgenden Bedingungen akzeptiert.
            </p>
          </li>
          <li>
            <p>
              Durch die Nutzung der Dienste erklärt sich der Nutzer mit der
              Geltung dieser Nutzungsbedingungen einverstanden. Durch das
              Einverständnis garantiert der Nutzer, dass er keine Handlungen
              vornehmen wird, die gegen diese Nutzungsbedingungen verstoßen.
            </p>
          </li>
        </ol>
        <div style={{ margin: "20px" }}></div>
        <h4>§ 2 Registrierung / Benutzerkonto</h4>
        <ol>
          <li>
            <p>
              Die Nutzung der Dienste erfordert eine einmalige Registrierung und
              das Anlegen eines persönlichen Benutzerkontos. Die Registrierung
              erfolgt zunächst für einen der genannten Dienste. Nach
              erfolgreicher Registrierung hat der Nutzer die Möglichkeit, sich
              für weitere Dienste freischalten zu lassen.
            </p>
          </li>
          <li>
            <p>
              Der Anbieter behält sich das Recht vor, einem Nutzer die
              Freischaltung eines Dienstes nach freiem Ermessen zu verweigern
              oder auch nachträglich den Zugang zu entziehen. Dies kann
              insbesondere dann geschehen, wenn zu befürchten ist, dass die
              Nutzung des Dienstes durch den konkreten Nutzer dem Zweck des
              Dienstes zuwiderlaufen könnte.
            </p>
          </li>
          <li>
            <p>
              Eine Registrierung ist nur im Rahmen der geschäftlichen Tätigkeit
              des Nutzers zulässig. Die Registrierung als Verbraucher gem. § 13
              BGB ist nicht zulässig.
            </p>
          </li>
          <li>
            <p>
              Der Nutzer verpflichtet sich, korrekte Angaben zu seiner Person zu
              machen. Des Weiteren verpflichtet sich der Nutzer dazu, seine
              Angaben aktuell zu halten.
            </p>
          </li>
          <li>
            <p>
              Der Nutzer ist für die Sicherstellung der Vertraulichkeit seines
              Kontos, Kennworts und für die Beschränkung des Zugangs zu seinem
              Computer und seinen mobilen Geräten verantwortlich. Soweit unter
              anwendbarem Recht zulässig, erklärt sich der Nutzer damit
              einverstanden, für alle Aktivitäten verantwortlich zu sein, die
              über sein Konto vorgenommen werden. Der Nutzer ist verpflichtet
              sicherzustellen, dass sein Kennwort geheim gehalten und sicher
              aufbewahrt wird. Weiterhin soll er den Anbieter unverzüglich
              informieren, wenn Anlass zur Sorge besteht, dass ein Dritter
              Kenntnis von dem Kennwort des Nutzers erlangt hat oder dies zu
              befürchten ist. Der Nutzer hat sicherzustellen, dass die von ihm
              gemachten Angaben korrekt und vollständig sind und dass der
              Anbieter unverzüglich über jegliche Änderungen informiert wird.
              Der Nutzer kann die angegebenen Informationen in seinem
              Benutzerkonto jederzeit einsehen und aktualisieren.
            </p>
          </li>
          <li>
            <p>
              Der Nutzer kann seinen Benutzernamen und sein Kennwort
              nachträglich jederzeit ändern.
            </p>
          </li>
          <li>
            <p>
              Der Nutzer darf keine Handlungen vornehmen, die dazu geeignet
              sind, die Dienste oder den Zugang zu den Diensten zu unterbrechen,
              zu beschädigen oder in sonstiger Art zu beeinträchtigen.
            </p>
          </li>
          <li>
            <p>
              Der Nutzer kann sein Konto jederzeit löschen, indem er die
              entsprechende Schaltfläche in seinem Benutzerkonto betätigt. Die
              Löschung des Benutzerkontos wird dann eingeleitet. Der Nutzer,
              inklusive der angegebenen personenbezogenen Daten, wird dann durch
              den Anbieter gelöscht. Der Nutzer wird informiert, sobald das
              Benutzerkonto erfolgreich gelöscht wurde.
            </p>
          </li>
          <li>
            <p>
              Sofern der Nutzer im Rahmen des Dienstes „<b>My Toolbox</b>“ oder
              der „<b>Partner Lounge</b>“ Produkte registriert und diese mit
              mindestens einem weiteren Nutzer über die Team-Funktion geteilt
              hat, ist der Anbieter berechtigt, die registrierten Produkte einem
              anderen Nutzer des entsprechenden Teams zuzuweisen, sofern dieser
              zustimmt und über die erforderliche Berechtigung verfügt (vgl. § 4
              Ziff. 2).
            </p>
          </li>
        </ol>
        <div style={{ margin: "20px" }}></div>
        <h4>§ 3 Verfügbarkeit der Dienste</h4>
        <ol>
          <li>
            <p>
              Der Anbieter ist bemüht, die Dienste 7 Tage pro Woche, 24 Stunden
              am Tag zur Verfügung zu stellen. Der Nutzer hat jedoch keinen
              Anspruch auf jederzeitige Verfügbarkeit der Dienste. Insbesondre
              aufgrund von erforderlichen und regelmäßigen Wartungsarbeiten kann
              es jedoch zu Unterbrechungen der Verfügbarkeit kommen. Weiterhin
              können Ursachen die Verfügbarkeit einschränken, die außerhalb des
              Einflussbereichs des Anbieters liegen.
            </p>
          </li>
          <li>
            <p>
              Der Anbieter weist darauf hin, dass es aus technischen Gründen
              nicht möglich ist, die Dienste jederzeit fehlerfrei zur Verfügung
              zu stellen, weshalb der Anbieter eine diesbezügliche Verantwortung
              ausschließt.
            </p>
          </li>
          <li>
            <p>
              Der Anbieter behält sich das Recht vor, die Dienste jederzeit nach
              freiem Ermessen ohne Vorankündigung vorübergehend oder auch
              dauerhaft abzuschalten.
            </p>
          </li>
        </ol>
        <div style={{ margin: "20px" }}></div>
        <h4>§ 4 Allgemeine Pflichten des Nutzers</h4>
        <ol>
          <li>
            <p>
              Der Nutzer ist verpflichtet ausschließlich wahre und eindeutige
              Angaben zu machen. Er ist verpflichtet, die von ihm gemachten
              Angaben zu aktualisieren, sofern erforderlich.
            </p>
          </li>
          <li>
            <p>
              Sofern der Nutzer den Dienst „<b>My Toolbox</b>“ oder die „
              <b>Partner Lounge</b>“ nutzt, darf dieser dort nur dann Produkte
              registrieren, sofern und soweit er hierzu vom Eigentümer des
              Systems (Unternehmen) berechtigt ist. Jedes System kann nur für
              einen einzigen Nutzer registriert werden. Über die Team-Funktion
              besteht die Möglichkeit, die Daten des Systems mit anderen Nutzern
              zu teilen. Insofern versichert der Nutzer, dass er über die
              entsprechende Berechtigung zur Registrierung des Systems verfügt.
              Der Nutzer ist weiterhin verpflichtet, den Anbieter unverzüglich
              zu informieren, wenn er nicht mehr für das Unternehmen tätig ist,
              in welchem das registrierte System eingesetzt wird, da in diesem
              Fall davon auszugehen ist, dass der Nutzer nicht mehr über die
              benötigte Berechtigung verfügt. Der Anbieter ist in diesem Fall
              nach Rücksprache mit dem Unternehmen berechtigt, die von dem
              Nutzer registrierten Systeme auf einen anderen Nutzer des
              Unternehmens zu übertragen, sofern dieser Nutzer zustimmt.
            </p>
          </li>
          <li>
            <p>
              Sofern der Nutzer Bilder zu den registrierten Produkten hoch lädt,
              versichert der Nutzer, dass dadurch keine Rechte Dritter verletzt
              werden. Die Bilder werden ausschließlich im Rahmen des Dienstes
              genutzt. Der Anbieter wird die Bilder nicht an Dritte weitergeben,
              sofern der Nutzer dem nicht ausdrücklich zustimmt.
            </p>
          </li>
          <li>
            <p>
              Der Nutzer ist verpflichtet, keine Handlungen vorzunehmen, die
              geeignet sind, die Funktionalität der Dienste und/oder der
              zugrundeliegenden Infrastruktur zu beeinträchtigen, insbesondere
              diese übermäßig zu belasten.
            </p>
          </li>
        </ol>
        <div style={{ margin: "20px" }}></div>
        <h4>§ 5 Urheberrecht</h4>
        <ol>
          <li>
            <p>
              Der gesamte im Rahmen des Dienstes bereitgestellte Inhalt, wie
              Texte, Zeichnungen, Bilder, Videos und Datenbanken, ist
              urheberrechtlich geschütztes Eigentum des Anbieters oder von
              Dritten, die dem Anbieter Inhalte zur Nutzung überlassen haben.
            </p>
          </li>
          <li>
            <p>
              Die Inhalte dürfen ausschließlich zu dem jeweils vorgesehenen
              Zweck genutzt werden, es sei denn, der Anbieter hat einer
              weitergehenden Nutzung schriftlich zugestimmt.
            </p>
          </li>
          <li>
            <p>
              Die Inhalte dürfen ohne vorherige Zustimmung des Anbieters weder
              im Ganzen noch in Teilen in irgendeiner Art vervielfältigt,
              öffentlich wiedergegeben und/oder an Dritte weitergegeben werden.
            </p>
          </li>
        </ol>
        <div style={{ margin: "20px" }}></div>
        <h4>§ 6 Haftung</h4>
        <ol>
          <li>
            <p>
              Der Anbieter ist stets bemüht sicherzustellen, dass die im Rahmen
              der Dienste bereitgestellten Inhalte und Informationen frei von
              Fehlern sind. Dennoch übernimmt der Anbieter, soweit rechtlich
              zulässig, keine Gewähr für die Richtigkeit der Informationen (s. §
              6 Ziff. 2).
            </p>
          </li>
          <li>
            <p>
              Der Anbieter haftet unbeschränkt, soweit die Schadensursache auf
              einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung des
              Anbieters oder eines gesetzlichen Vertreters oder
              Erfüllungsgehilfen des Anbieters beruht.
            </p>
          </li>
          <li>
            <p>
              Ferner haftet der Anbieter für die einfach fahrlässige Verletzung
              von wesentlichen Pflichten. Wesentlich sind Pflichten, deren
              Verletzung die Erreichung des Vertragszwecks gefährdet oder deren
              Erfüllung die ordnungsgemäße Durchführung des Vertrages überhaupt
              erst ermöglicht und auf deren Einhaltung der Nutzer regelmäßig
              vertraut. In diesem Fall ist die Haftung jedoch auf den
              vorhersehbaren, vertragstypischen Schaden begrenzt. Im Übrigen ist
              eine Haftung bei einfacher Fahrlässigkeit ausgeschlossen.
            </p>
          </li>
          <li>
            <p>
              Die vorstehenden Haftungsbeschränkungen gelten nicht bei
              Verletzung von Leben, Körper und Gesundheit, für einen Mangel nach
              Übernahme einer Garantie für die Beschaffenheit des Produktes und
              bei arglistig verschwiegenen Mängeln. Die Haftung nach dem
              Produkthaftungsgesetz bleibt unberührt.
            </p>
          </li>
          <li>
            <p>
              Soweit die Haftung des Anbieters nach den vorstehenden
              Bestimmungen ausgeschlossen oder begrenzt ist, gilt dies auch für
              die persönliche Haftung von Arbeitnehmern, Vertretern und
              Erfüllungsgehilfen des Anbieters.
            </p>
          </li>
        </ol>
        <div style={{ margin: "20px" }}></div>
        <h4>§ 7 Datenschutz</h4>
        <ol>
          <li>
            <p>
              Im Rahmen der Erstellung des Benutzerkontos erhebt der Anbieter
              personenbezogene Daten des Nutzers. Die vom Nutzer angegebenen
              Daten werden in der Nutzerdatenbank des Anbieters gespeichert. Die
              Datenerhebung ist erforderlich, um die Leistungen im Rahmen der
              Dienste erbringen zu können.
            </p>
          </li>
          <li>
            <p>
              Der Anbieter wird die Daten in keinem Fall an Dritte weitergeben,
              es sei denn, der Nutzer hat vorab in die Weitergabe eingewilligt.
            </p>
          </li>
          <li>
            <p>
              Weitere Angaben zum Datenschutz enthält die Datenschutzerklärung
              des Anbieter:{" "}
              <Link
                href="https://www.luebbering.de/datenschutz"
                target="_blank"
              >
                www.luebbering.de/datenschutz
              </Link>
              .
            </p>
          </li>
        </ol>
        <div style={{ margin: "20px" }}></div>
        <h4>§ 8 Gerichtsstand und anwendbares Recht</h4>
        <ol>
          <li>
            <p>
              Gerichtsstand ist Bielefeld. Es gilt ausschließlich deutsches
              Recht.
            </p>
          </li>
        </ol>
        <div style={{ margin: "20px" }}></div>
        <h4>§ 9 Schlussbestimmungen</h4>
        <ol>
          <li>
            <p>
              Der Anbieter behält sich das Recht vor, jederzeit nach freiem
              Ermessen Änderungen an den Diensten und Bedingungen,
              einschließlich dieser Nutzungsbedingungen, vorzunehmen.
            </p>
          </li>
          <li>
            <p>
              Sollten einzelne Bestimmungen dieser Nutzungsbedingungen unwirksam
              sein, berührt dies den Vertrag im Übrigen nicht. Die Parteien
              verpflichten sich in diesem Fall, an die Stelle der unwirksamen
              Bestimmung eine solche zu setzen, die dem Gewollten zweckmäßig am
              nächsten kommt.
            </p>
          </li>
        </ol>
      </div>
    </div>
  );

  const termsEN = (
    <div>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            <Button
              icon={<DocumentPersonRegular fontSize={24} color="#ff6600" />}
              appearance="subtle"
            >
              {i18n.t<string>("terms-of-use").toLocaleUpperCase()}
            </Button>
          </StackShim>
        }
      />

      <div className="lueb-ContentBlock">
        <p className="mt-3">Welcome to LÜBBERING DIGITAL!</p>
        <p>
          We kindly ask you to read the following Conditions of Use for Services
          offered as part of LÜBBERING DIGITAL with care. The Conditions of Use
          apply to every user of these Services.
        </p>
        <p>
          In order to register and use LÜBBERING DIGITAL, you need to agree to
          the validity of the Conditions of Use. You grant your consent by
          placing the appropriate check mark at the end of the registration
          process. Registration and use of the Services is not possible without
          your consent.
        </p>
        <div style={{ margin: "10px" }}></div>
        <p>The provider of LÜBBERING DIGITAL is:</p>
        <div>Johannes Lübbering GmbH</div>
        <div>Industriestraße 4</div>
        <div className="mb-3">33442 Herzebrock-Clarholz</div>
        <div>Telephone: +49 (0) 5245 - 8309 0</div>
        <div className="mb-3">
          E-Mail:{" "}
          <Link href="mailto:info@luebbering.de">info@luebbering.de</Link>
        </div>
        <div className="mb-3">Managing Director: Achim Lübbering</div>
        <div>Court of registration: Gütersloh District Court</div>
        <div>Register number: HRB 5832</div>
        <p>
          The provider reserves the right to change the information and services
          of LÜBBERING DIGITAL at any time without prior notice, to delete such
          information and services in part or in full, or to supplement such
          services and information.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h4>§ 1 Scope of application</h4>
        <ol>
          <li>
            <p>
              The following conditions apply to use of the Services offered as
              part of LÜBBERING DIGITAL (hereinafter referred to as "Services”
              or “Service”).
            </p>
            <div>The following Services are included at present:</div>
            <ul className="lueb-listWithPlusIcon">
              <li>
                <div>L.SP3 Configurator and Quick Finder:</div>
                <p>
                  L.SP3 Configurator and Quick Finder are aimed at customers and
                  prospective customers. It is possible to configure complete
                  fastening systems and carry out a quick search as a means of
                  checking whether a standard geared offset head or angle head
                  can be used for the respective application.
                </p>
              </li>
              <li>
                <div>My Toolbox:</div>
                <p>
                  My Toolbox is aimed exclusively at (end) customers who are
                  actually using the provider’s fastening systems (products).
                  Users (e.g. planners, maintenance staff, etc.) can register
                  products, which are currently in use, in My Toolbox. This
                  grants them access to technical product data as well as
                  further information about maintenance and product use. In
                  addition, users receive assistance in relation to the
                  procurement of spare parts and they can clearly organise
                  products that are currently in use.
                </p>
              </li>
              <li>
                <div>Partner Lounge:</div>
                <p>
                  Partner Lounge offers the same functions as "My Toolbox", but
                  is aimed exclusively at distributors and dealers who sell the
                  supplier's fastening systems (products).
                </p>
              </li>
              <li>
                <div>Lübbering Academy:</div>
                <p>
                  The Lübbering Academy is primarily aimed at the end users of
                  Lübbering fastening tools and at the persons responsible for
                  system maintenance. Users can find out about suitable training
                  opportunities, manage and arrange training, as well as access
                  product videos and digital training materials.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              User acceptance of the conditions stated below is a prerequisite
              for using the Services.
            </p>
          </li>
          <li>
            <p>
              By using the Services, the user agrees to the validity of these
              Conditions of Use. By agreeing, the user guarantees that he will
              not act in any way that breaches these Conditions of Use.
            </p>
          </li>
        </ol>
        <div style={{ margin: "20px" }}></div>
        <h4>§ 2 Registration / User account</h4>
        <ol>
          <li>
            <p>
              The user is required to register once and create a personal user
              account in order to use the Services. Registration is initially
              for one of the stated Services. After registering successfully,
              the user is able to activate himself for further Services.
            </p>
          </li>
          <li>
            <p>
              The provider reserves the right to refuse to activate a Service
              for a user at the provider’s own discretion or to withdraw access
              at a subsequent point in time. This may, in particular, be the
              case if there is reason to suspect that use of the Service by the
              specific user could be contrary to the purpose of the Service.
            </p>
          </li>
          <li>
            <p>
              Registration is only permitted in connection with the user’s
              business activities. Registration as a consumer is not permitted
              in accordance with § 13 BGB (German Civil Code).
            </p>
          </li>
          <li>
            <p>
              The user is obligated to provide accurate personal data.
              Furthermore, the user is obligated to keep his personal data
              up-to-data.
            </p>
          </li>
          <li>
            <p>
              The user is responsible for ensuring the confidentiality of his
              account, password and for restricting access to his computer and
              mobile devices. Insofar as permissible under the applicable law,
              the user agrees to be responsible for all activities performed via
              his account. The user is obligated to ensure that his password is
              kept secret and secure. Furthermore, he is to notify the provider
              immediately if there is any concern that a third party has gained
              knowledge of the user's password or if such an occurrence is to be
              suspected. The user is to ensure that the information provided by
              him is correct and complete and that the provider is notified
              immediately in the event of any changes. The user can view and
              update the information provided in his user account at any time.
            </p>
          </li>
          <li>
            <p>
              The user can subsequently change his user name and password at any
              time.
            </p>
          </li>
          <li>
            <p>
              The user must not act in any way that is likely to disrupt, damage
              or otherwise impair the Services or access to the Services.
            </p>
          </li>
          <li>
            <p>
              The user can delete his account at any time by clicking on the
              relevant button in his user account. This then initiates the
              deletion of the user account. The user, including the personal
              data he has provided, is then deleted by the provider. The user is
              notified as soon as his user account has been successfully
              deleted.
            </p>
          </li>
          <li>
            <p>
              Insofar as the user has registered products as part of the "
              <b>My Toolbox</b>" or "<b>Partner Lounge</b>" Service and shared
              them with at least one other user via the Team function, the
              provider is entitled to assign the registered products to another
              user of the Team in question, provided that said user agrees and
              has the required authorisation (cf. § 4(2)).
            </p>
          </li>
        </ol>
        <div style={{ margin: "20px" }}></div>
        <h4>§ 3 Availability of the Services</h4>
        <ol>
          <li>
            <p>
              The provider endeavours to provide the Services 7 days a week, 24
              hours a day. However, the user does not have any right to
              uninterrupted availability of the Services. Particularly due to
              necessary and routine maintenance work, however, availability may
              be interrupted. Furthermore, causes outside the provider’s control
              may restrict availability.
            </p>
          </li>
          <li>
            <p>
              The provider expressly references the fact that, for technical
              reasons, it is not possible to provide the Services without errors
              at all times. Consequently, the provider excludes any
              responsibility in this regard.
            </p>
          </li>
          <li>
            <p>
              The provider reserves the right to temporarily or permanently
              deactivate the Services at any time, at his own discretion, and
              without prior notice.
            </p>
          </li>
        </ol>
        <div style={{ margin: "20px" }}></div>
        <h4>§ 4 General obligations of the user</h4>
        <ol>
          <li>
            <p>
              The user is obligated to provide only accurate and unambiguous
              data. He is obligated to update the data he has provided, insofar
              as necessary.
            </p>
          </li>
          <li>
            <p>
              Insofar as the user uses the "<b>My Toolbox</b>" or "
              <b>Partner Lounge</b>" Service, he may only register products via
              this Service if and insofar as he is authorised to do so by the
              owner of the system (company). Each system can only be registered
              for a single user. System data can be shared with other users via
              the Team function.
              <br />
              In this regard, the user affirms that he has the appropriate
              authorisation for system registration. The user is also obligated
              to notify the provider, immediately, if he no longer works for the
              company in which the registered system is used, as it can be
              assumed in such cases that the user no longer has the necessary
              authorisation. In this event, the provider is entitled, following
              consultation with the company, to transfer the systems registered
              by the user to another user of the company, provided that said
              user agrees.
            </p>
          </li>
          <li>
            <p>
              Insofar as the user uploads images relating to the registered
              products, the user affirms that no third party rights are breached
              as a result of such uploads. The images are used solely as part of
              the Service. The provider will not transfer the images to third
              parties unless the user expressly agrees to such a transfer.
            </p>
          </li>
          <li>
            <p>
              The user is obligated to refrain from acting in any way that is
              likely to impair the functionality of the Services and/or the
              underlying infrastructure. This specifically includes the
              excessive overloading of such Services and infrastructure.
            </p>
          </li>
        </ol>
        <div style={{ margin: "20px" }}></div>
        <h4>§ 5 Copyright</h4>
        <ol>
          <li>
            <p>
              The entire content provided as part of the Service (such as texts,
              drawings, images, videos and databases) is the copyrighted
              property of the provider or of third parties who have given the
              provider content for use.
            </p>
          </li>
          <li>
            <p>
              The content may only be used for the intended purpose, unless the
              provider has agreed, in writing, to a broader use.
            </p>
          </li>
          <li>
            <p>
              The content may not be reproduced in any way, in whole or in part,
              communicated to the public and/or transferred to third parties
              without the prior consent of the provider.
            </p>
          </li>
        </ol>
        <div style={{ margin: "20px" }}></div>
        <h4>§ 6 Liability</h4>
        <ol>
          <li>
            <p>
              The provider always endeavours to ensure that the content and
              information provided as part of the Services are free of errors.
              Nevertheless, insofar as permissible by law, the provider does not
              guarantee the accuracy of the information (see § 6(2)).
            </p>
          </li>
          <li>
            <p>
              The provider is liable without limitation insofar as the cause of
              damage is based on an intentional or grossly negligent breach of
              duty on the part of the provider or on the part of a legal
              representative or vicarious agent of the provider.
            </p>
          </li>
          <li>
            <p>
              Furthermore, the provider is liable for the simple negligent
              breach of material obligations. Material obligations are
              obligations, the breach of which jeopardises the achievement of
              the contractual purpose, or the fulfillment of which makes proper
              performance of the contract possible in the first place and with
              which the user may reasonably expect compliance. In such cases,
              however, liability is limited to the foreseeable damage typical of
              the contract. In all other cases, liability for simple negligence
              is excluded.
            </p>
          </li>
          <li>
            <p>
              The aforementioned limitations of liability do not apply in the
              event of injury to life, limb or health; for a defect after
              acceptance of a guarantee for the quality of the product, or in
              the event of fraudulently concealed defects. Liability as per the
              German Product Liability Act remains unaffected.
            </p>
          </li>
          <li>
            <p>
              Insofar as the liability of the provider is excluded or limited in
              accordance with the aforementioned provisions, such an exclusion
              or limitation also applies in relation to the personal liability
              of employees, representatives and vicarious agents of the
              provider.
            </p>
          </li>
        </ol>
        <div style={{ margin: "20px" }}></div>
        <h4>§ 7 Data protection</h4>
        <ol>
          <li>
            <p>
              In the course of creating the user account, the provider collects
              personal data of the user. The data provided by the user is stored
              in the provider's user database. Data collection is necessary for
              enabling provision of services as part of the Services.
            </p>
          </li>
          <li>
            <p>
              The provider will not transfer the data to third parties under any
              circumstances, unless the user has consented to such a transfer in
              advance.
            </p>
          </li>
          <li>
            <p>
              Further information about data protection can be found in the
              provider's privacy statement:{" "}
              <Link href="https://www.luebbering.de/en/privacy" target="_blank">
                https://www.luebbering.de/en/privacy
              </Link>
              .
            </p>
          </li>
        </ol>
        <div style={{ margin: "20px" }}></div>
        <h4>§ 8 Place of jurisdiction and applicable law</h4>
        <ol>
          <li>
            <p>
              Bielefeld is the place of jurisdiction. German law applies
              exclusively.
            </p>
          </li>
        </ol>
        <div style={{ margin: "20px" }}></div>
        <h4>§ 9 Final provisions</h4>
        <ol>
          <li>
            <p>
              The provider reserves the right to make changes to the Services
              and Conditions, including these Conditions of Use, at any time and
              at his own discretion.
            </p>
          </li>
          <li>
            <p>
              Should individual provisions of these Conditions of Use be
              ineffective, this does not affect the other provisions of the
              contract. In such cases, the parties are obligated to replace the
              ineffective provision with a provision that comes closest to the
              intended purpose.
            </p>
          </li>
        </ol>
      </div>
    </div>
  );

  return i18n.language.includes("de") ? termsDE : termsEN;
}

export default TermsOfUse;
